module.exports = __webpack_public_path__ + "fbd0cc4f8bc5db29bce94b933186628b.png";